import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";
import type { IBreadcrumbBanner } from "@/types/page";

export async function createBreadcrumbBanner(
  payload: Partial<IBreadcrumbBanner>
) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.BREADCRUMB_BANNER.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateBreadcrumbBanner(
  id: number,
  payload: Partial<IBreadcrumbBanner>
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.BREADCRUMB_BANNER.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
